import { CURRENCIES, DEFAULT_CURRENCY } from 'src/i18n/currencies/constants'

const baseCurrency = {
  style: 'currency'
}

const baseCurrencyNoCents = {
  style: 'currency',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
}

const baseCurrencyHundredths = {
  style: 'currency',
  minimumFractionDigits: 4,
  maximumFractionDigits: 4
}

/**
 * Number formats for VueI18n. On these, the locale fallbacks apparently only apply
 * within the base language (e.g. 'en' or 'es'). Maybe a bug in VueI18n. So we must
 * repeatedly define the 'es' formats as well (done after the object below). All English
 * locales successfully fallback to the 'en' definitions. These must match the options
 * available in the Intl.NumberFormat constructor.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#parameters
 */
const numberFormats = {
  en: {
    decimal: {
      style: 'decimal'
    },
    decimal0: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    decimal1: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 1
    },
    decimalExactly1: {
      style: 'decimal',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    },
    decimal2: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    },
    decimalExactly2: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    compact: {
      notation: 'compact',
      compactDisplay: 'short',
      minimumFractionDigits: 0,
      maximumFractionDigits: 1
    }
  },
  'en-US': {
    currency: {
      ...baseCurrency,
      currency: CURRENCIES.USD
    },
    currencyNoCents: {
      ...baseCurrencyNoCents,
      currency: CURRENCIES.USD
    },
    currencyHundredths: {
      ...baseCurrencyHundredths,
      currency: CURRENCIES.USD
    }
  },
  'en-PR': {
    currency: {
      ...baseCurrency,
      currency: CURRENCIES.USD
    },
    currencyNoCents: {
      ...baseCurrencyNoCents,
      currency: CURRENCIES.USD
    },
    currencyHundredths: {
      ...baseCurrencyHundredths,
      currency: CURRENCIES.USD
    }
  },
  'en-CA': {
    currency: {
      ...baseCurrency,
      currency: CURRENCIES.CAD
    },
    currencyNoCents: {
      ...baseCurrencyNoCents,
      currency: CURRENCIES.CAD
    },
    currencyHundredths: {
      ...baseCurrencyHundredths,
      currency: CURRENCIES.CAD
    }
  },
  'en-AU': {
    currency: {
      ...baseCurrency,
      currency: CURRENCIES.AUD
    },
    currencyNoCents: {
      ...baseCurrencyNoCents,
      currency: CURRENCIES.AUD
    },
    currencyHundredths: {
      ...baseCurrencyHundredths,
      currency: CURRENCIES.AUD
    }
  },
  'en-GB': {
    currency: {
      ...baseCurrency,
      currency: CURRENCIES.GBP
    },
    currencyNoCents: {
      ...baseCurrencyNoCents,
      currency: CURRENCIES.GBP
    },
    currencyHundredths: {
      ...baseCurrencyHundredths,
      currency: CURRENCIES.GBP
    }
  },
  'en-IE': {
    currency: {
      ...baseCurrency,
      currency: CURRENCIES.EUR
    },
    currencyNoCents: {
      ...baseCurrencyNoCents,
      currency: CURRENCIES.EUR
    },
    currencyHundredths: {
      ...baseCurrencyHundredths,
      currency: CURRENCIES.EUR
    }
  },
  'en-NZ': {
    currency: {
      ...baseCurrency,
      currency: CURRENCIES.NZD
    },
    currencyNoCents: {
      ...baseCurrencyNoCents,
      currency: CURRENCIES.NZD
    },
    currencyHundredths: {
      ...baseCurrencyHundredths,
      currency: CURRENCIES.NZD
    }
  },
  es: {
    decimal: {
      style: 'decimal'
    },
    decimal0: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    decimal1: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 1
    },
    decimalExactly1: {
      style: 'decimal',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    },
    decimal2: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    },
    decimalExactly2: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    currency: {
      ...baseCurrency,
      currency: DEFAULT_CURRENCY
    },
    currencyNoCents: {
      ...baseCurrencyNoCents,
      currency: DEFAULT_CURRENCY
    },
    currencyHundredths: {
      ...baseCurrencyHundredths,
      currency: DEFAULT_CURRENCY
    }
  },
  'es-PR': {
    currency: {
      ...baseCurrency,
      currency: DEFAULT_CURRENCY
    },
    currencyNoCents: {
      ...baseCurrencyNoCents,
      currency: DEFAULT_CURRENCY
    },
    currencyHundredths: {
      ...baseCurrencyHundredths,
      currency: DEFAULT_CURRENCY
    }
  }
}
export default numberFormats
